export const format = (num, fraction = 0) => new Intl.NumberFormat([], {
  minimumFractionDigits: fraction,
  maximumFractionDigits: fraction,
}).format(num);

const jsonWrite = (method, url, data) => {
  return fetch(url, {
    method: method,
    body: JSON.stringify(data),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then(res => {
    if(res.status != 200){
      throw {res: res, msg: 'Error communicating with the server'};
    }
    return res.json()
  })
}

export const db = {
  del: (url) => fetch(url, {
      method: 'delete',
      headers: {'Accept': 'application/json'},
    })
    .then(res => {
      if(res.status != 200){
        throw {res: res, msg: 'Error communicating with the server'};
      }
      return res.json()
    }
  ),
  get: (url) => fetch(url, {
      headers: {'Accept': 'application/json'},
    })
    .then(res => {
      if(res.status != 200){
        throw {res: res, msg: 'Error communicating with the server'};
      }
      return res.json()
    }
  ),
  str: (data) => JSON.stringify(data),
  patch: (url, data) => jsonWrite('PATCH', url, data),
  post: (url, data) => jsonWrite('POST', url, data),
  put: (url, data) => jsonWrite('PUT', url, data),
  obj: (str) => JSON.parse(str),
}

export const array = {
  diff: (a1, a2) => a1.filter(x => !a2.includes(x)),
  intersect: (a1, a2) => a1.filter(x => a2.includes(x)),
  symetric_diff: (a1, a2) => a1.filter(x => !a2.includes(x)).concat(a2.filter(x => !a1.includes(x))),
  union: (a1, a2) => [...new Set([...a1, ...a2])],
}
